import React from 'react';
import styled from 'styled-components';
import { FormTitle } from '../customComponents/FormTitle';
import { useLang } from '../context/LangContext';
import { formatPriceByLanguage } from '../utils/currency';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 24px;
`;

const Content = styled.div`
  padding: 16px 0;
`;

// 가격 정보 컨테이너 (AuctionInfo와 동일한 스타일)
const PriceContainer = styled.div<{ $hasLabel?: boolean }>`
  background-color: #f3f6f6;
  border-radius: 10px;
  padding: 12px 16px;
  display: flex;
  justify-content: ${({ $hasLabel }) => ($hasLabel ? 'space-between' : 'flex-end')};
  align-items: center;
`;

// 가격 레이블 (왼쪽)
const PriceLabel = styled.div`
  font-size: 14px;
  color: #333;
  font-weight: 500;
`;

// 가격 값 (오른쪽)
const PriceValue = styled.div`
  font-size: 14px;
  color: #000;
  font-weight: 600;
  text-align: right;
`;

interface LotPriceProps {
  title?: string;
  priceLabel?: string;
  priceValue?: number;
  exchangeRate?: number;
}

// 다국어 텍스트
const lotPriceTexts = {
  ko: {
    title: 'LOT 가격',
    startPrice: '시작가'
  },
  en: {
    title: 'LOT Price',
    startPrice: 'Starting Price'
  }
};

const LotPrice: React.FC<LotPriceProps> = ({ 
  title,
  priceLabel,
  priceValue = 30000000,
  exchangeRate = 1300 // 기본 환율
}) => {
  const { lang } = useLang();
  const texts = lotPriceTexts[lang];
  
  // props로 받은 값이 없으면 기본 다국어 텍스트 사용
  const sectionTitle = title || texts.title;
  const labelText = priceLabel !== undefined ? priceLabel : texts.startPrice;

  // 언어별 단일 통화 표시
  const formattedPrice = formatPriceByLanguage(priceValue, exchangeRate, lang);

  return (
    <Container>
      <FormTitle>{sectionTitle}</FormTitle>
      <Content>
        <PriceContainer $hasLabel={!!labelText}>
          {labelText && <PriceLabel>{labelText}</PriceLabel>}
          <PriceValue>{formattedPrice}</PriceValue>
        </PriceContainer>
      </Content>
    </Container>
  );
};

export default LotPrice;
